import React from 'react';
import ReactOnRails from 'react-on-rails';

import ErrorBoundary from 'components/error_boundary';

export function unmountChildComponents(parentElement) {
  const roots = (typeof window !== 'undefined' && window.roots) || [];

  parentElement.querySelectorAll('.js-react-on-rails-component').forEach((element) => {
    const mountedElement = document.getElementById(element.dataset.domId);
    if (!mountedElement) return;

    const index = roots.findIndex(root => root?._internalRoot?.containerInfo === mountedElement);
    if (index > -1) {
      const [root] = roots.splice(index, 1);
      queueMicrotask(() => root.unmount());
    }
  });
}

export function registerWithErrorBoundary(components) {
  const errorBoundryWrapper = Object.fromEntries(
    Object.entries(components).map(([name, Component]) => {
      function ErrorBoundryWrapper(props) {
        return React.createElement(ErrorBoundary, null, React.createElement(Component, props));
      }

      return [name, ErrorBoundryWrapper];
    })
  );

  ReactOnRails.register(errorBoundryWrapper);
}
